import { Component, OnInit } from '@angular/core';
import { PersonService } from '../../../person/services/person.service';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-people',
  templateUrl: './list-people.component.html',
  styleUrls: ['./list-people.component.css'],
  providers:[PersonService]
})
export class ListPeopleComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  people:any = [];
  filters:any = {
    nif:{contains: ""},
    name: {contains: ""},
    surname: {contains: ""},
    born_date: {contains: ""},
    nif_expiration_date: {contains: ""},
    address: {contains: ""},
    cp: {contains: ""},
    town: {contains: ""},
    state: {contains: ""},
    telephone: {contains: ""}
  };
  showExportButton:boolean = true;
  exportParams:any = {};
  role:number = 3;

  constructor(private personService: PersonService) { }

  ngOnInit() {
    if (location.href.split('?')[1]){
      this.filters = JSON.parse(localStorage.getItem('people-filter')); 
    }
    this.getPeople();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getPeople(){
    localStorage.setItem('people-filter',JSON.stringify(this.filters));
    location.href = location.href.split('?')[0]+"?filters=true";
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'nif DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (params.where.born_date.contains !== ""){
      params.where.born_date.contains = moment(this.filters.born_date.contains, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (params.where.nif_expiration_date.contains !== ""){
      params.where.nif_expiration_date.contains = moment(this.filters.nif_expiration_date.contains, "DD-MM-YYYY").format("YYYY-MM-DD");
    }

    this.exportParams = params;
    this.personService.query(params)
               .subscribe((people) => {
                  this.people = people;
                  let countParams = {
                    where: _.cloneDeep(params.where),
                  };
                  this.personService.count(countParams)
                  .subscribe((count) => {
                    this.totalItems = count.count;
                  });
                });
  }

  exportPeopleToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {            
              field1:"NIF",
              field2:"Nombre",
              field3:"Apellidos",
              field4:"Fecha de nacimiento",
              field5:"Fecha de caducidad nif",
              field6:"Dirección",
              field7:"Ciudad",
              field8:"Provincia",
              field9:"Código Postal",
              field10:"Email",
              field11:"Teléfono",
              field12:"Teléfono 2",
              field13:"Advertencia",
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observablePeopleRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100)
        this.exportParams.limit = 100;
        observablePeopleRequest.push(this.personService.query(this.exportParams));
      }
      Observable.forkJoin(observablePeopleRequest)
          .subscribe(data => {
            let p:any = data;
            let people = p.flat(); 
            people.forEach(person =>{
                  if (person.short_description){
                    person.waring = person.waring.replace(/</g, '');
                    person.waring = person.waring.replace(/>/g, '');
                    person.waring = person.waring.replace(/;/g, '');
                    person.waring = person.waring.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  var row = {
                      field1:person.nif?person.nif:"",
                      field2:person.name?person.name:"",
                      field3:person.surname?person.surname:"",
                      field4:person.born_date?moment(person.born_date).format("DD-MM-YYYY"):"",
                      field5:person.nif_expiration_date?moment(person.nif_expiration_date).format("DD-MM-YYYY"):"",
                      field6:person.address?person.address:"",
                      field7:person.town?person.town:"",
                      field8:person.state?person.state:"",
                      field9:person.cp?person.cp:"",
                      field10:person.email?person.email:"",
                      field11:person.telephone?person.telephone:"",
                      field12:person.mobile?person.mobile:"",
                      field13:person.warning?person.warning:"",
                  }
                  report.push(row);
              });
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:100,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE PROVEEDORES'},
                      {columnid:'field4',width:100,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''},
                      {columnid:'field7',width:100,title: ''},
                      {columnid:'field8',width:100,title: ''}, 
                      {columnid:'field9',width:100,title: ''}, 
                      {columnid:'field10',width:100,title: ''}, 
                      {columnid:'field11',width:100,title: ''}, 
                      {columnid:'field12',width:100,title: ''}, 
                      {columnid:'field13',width:100,title: ''}, 
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              }, 
                          6:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                             
                              }
                              },
                          7:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                                  },              
                              }
                            },
                            8:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                                    },              
                                }
                              },
                              9:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1,
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                                      },              
                                  }
                                },
                                10:{style:{
                                    Interior:{ 
                                        Color:"#95a5a6",
                                        Pattern:"Solid"
                                                },
                                    Alignment:{
                                        Horizontal: 'Center', 
                                        Vertical: 'Center',
                                        WrapText: 1,
                                            },
                                    Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                        },              
                                    }
                                  },
                                  11:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1,
                                              },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                          },              
                                      }
                                    },
                                    12:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1,
                                                },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                            },              
                                        }
                                      },
                      }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("ProductosEtiquetados_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/components/list-people/list-people.component.ts